import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import classes from "./Checkbox.scss";
import { CheckboxOn } from "SvgComponents";
import { colors } from "Constants";
import classNames from "classnames";
import { onEnterOrSpaceKeyDown } from "Utils";

class Checkbox extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      isChecked,
      label,
      isDisabled,
      checkBoxParentContainer,
      checkboxStyle,
      fill,
      style,
      offFill,
      labelStyles,
      onCheckboxClick,
      checkboxItemStyle,
    } = this.props;
    const checkboxContainer = classNames(
      { [classes.checkboxContainer]: true },
      { [classes.checkboxContainerActive]: isChecked }
    );
    const checkboxContainerDisable = classNames(
      { [classes.checkboxContainerDisable]: true },
      { [classes.checkboxContainerDisableActive]: isChecked }
    );

    return (
      <div
        className={isDisabled ? checkboxContainerDisable : checkboxContainer}
        style={checkBoxParentContainer}
        onClick={onCheckboxClick}
        tabIndex={0}
        onKeyDown={e =>
          onEnterOrSpaceKeyDown(e, e => {
            e.stopPropagation();
            onCheckboxClick();
          })
        }
        role="checkbox"
        aria-checked={isChecked}
      >
        <div
          style={checkboxStyle}
          className={isDisabled ? classes.disableCheckbox : classes.checkbox}
        >
          {isChecked ? (
            <div
              style={{
                backgroundColor: fill,
                opacity: isDisabled ? 0.5 : 1,
                height: style.height,
                width: style.width,
                ...checkboxItemStyle,
              }}
            >
              <CheckboxOn />
            </div>
          ) : (
            <div
              style={{
                opacity: isDisabled ? 0.5 : 1,
                height: style.height,
                width: style.width,
                border: `2px solid ${offFill}`,
                ...checkboxItemStyle,
              }}
            />
          )}
        </div>
        {!!label && (
          <div className={classes.checkboxLabel} style={labelStyles}>
            {label}
          </div>
        )}
      </div>
    );
  }
}

Checkbox.defaultProps = {
  offFill: colors.neutral500,
  fill: colors.teal200,
  style: {
    height: "16px",
    width: "16px",
  },
  checkboxStyle: {},
  checkboxItemStyle: {},
  onCheckboxClick: () => {},
};

Checkbox.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.object,
};

export default Checkbox;
